import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { IRootScope } from "@models";
import { currencies } from "@tools";

export interface IKbCurrencyFilter {
    (value: number, currencyCode?: string, precision?: number): string;
}
// declare module "angular" {
//     interface IFilterService {
//         (name: "kbCurrency"): IKbCurrencyFilter;
//     }
// }

@NgFilter({
    token: Token.KbCurrencyFilter,
    dependencies: [
        Token.$Filter,
        Token.$RootScope,
        Token.$Locale,
    ]
})
export class KbCurrencyFilter {
    constructor(
        $filter: ng.IFilterService,
        $rootScope: IRootScope,
        $locale: ng.ILocaleService
    ) {
        return ((value: number, currencyCode?: string, precision?: number) => {

            // if no iso given, then assume it's the company base currency
            // in future, should be the currency of the active quote
            if (!currencyCode) {
                // if ($rootScope.quote) {
                //    currencyCode = $rootScope.quote.currency;
                // }
                // else {
                currencyCode = $rootScope.companySettings.currency;
                // }
            }

            currencyCode = currencyCode.toUpperCase();

            let symbol = currencies[currencyCode] || "";
            let formatted: string = $filter("currency")(Number(value), undefined, precision);
            let localSymbol = $locale.NUMBER_FORMATS.CURRENCY_SYM;

            // replace local symbol in formatted with the real symbol
            formatted = formatted.replace(localSymbol, symbol);

            // add the iso code at the end
            formatted = formatted + " " + currencyCode;

            return formatted;
        }) as IKbCurrencyFilter as any;
    }
}
